export enum EventType {
    StartRegistration,
    EndRegistration,
    StartFencing,
    EndFencing,
    TrackingString,
    TrackingPoint
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/enums/event-type.ts